import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum CountryIconVariant {
  ko = 'ko',
  th = 'th',
  zh = 'zh',
  ja = 'ja',
}

interface ICountryIconProps extends IConDefaultType {
  variant: CountryIconVariant;
}

function CountryIcon({ className, size = 16, rotate, flip, variant }: ICountryIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: (size * 21.33) / 16,
        height: size,
        transform: `rotate(${rotate}deg)`,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {variant === CountryIconVariant.ko && (
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_7919_691676)">
            <mask
              id="mask0_7919_691676"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="22"
              height="16"
            >
              <path d="M0.164062 0H21.4974V16H0.164062V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_7919_691676)">
              <path fillRule="evenodd" clipRule="evenodd" d="M0.164062 0V16H21.4974V0H0.164062Z" fill="#F7FCFF" />
              <mask
                id="mask1_7919_691676"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="22"
                height="16"
              >
                <path fillRule="evenodd" clipRule="evenodd" d="M0.164062 0V16H21.4974V0H0.164062Z" fill="white" />
              </mask>
              <g mask="url(#mask1_7919_691676)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.8395 12.1457C13.1109 12.1457 14.9523 10.3043 14.9523 8.03282C14.9523 5.76133 13.1109 3.91992 10.8395 3.91992C8.56795 3.91992 6.72656 5.76133 6.72656 8.03282C6.72656 10.3043 8.56795 12.1457 10.8395 12.1457Z"
                  fill="#3D58DB"
                />
                <mask
                  id="mask2_7919_691676"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="6"
                  y="3"
                  width="9"
                  height="10"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.8262 12.1606C13.1033 12.1606 14.9493 10.3224 14.9493 8.05491C14.9493 5.7874 13.1033 3.94922 10.8262 3.94922C8.54908 3.94922 6.70312 5.7874 6.70312 8.05491C6.70312 10.3224 8.54908 12.1606 10.8262 12.1606Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2_7919_691676)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.0917 8.36936C15.0917 8.36936 14.8602 6.43336 13.1462 6.32827C11.4323 6.22317 10.9702 7.74796 10.8713 8.15196C10.7724 8.55596 10.522 9.63363 8.71739 9.63363C6.91282 9.63363 6.75 6.89336 6.75 6.89336V3.66211H15.0917V8.36936Z"
                    fill="#E31D1C"
                  />
                </g>
                <rect
                  x="16.7969"
                  y="9.05078"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(30 16.7969 9.05078)"
                  fill="#272727"
                />
                <rect
                  x="17.9531"
                  y="9.71484"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(30 17.9531 9.71484)"
                  fill="#272727"
                />
                <rect
                  x="19.1016"
                  y="10.3809"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(30 19.1016 10.3809)"
                  fill="#272727"
                />
                <rect
                  x="15.5547"
                  y="11.209"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(30 15.5547 11.209)"
                  fill="#272727"
                />
                <rect
                  x="16.7031"
                  y="11.875"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(30 16.7031 11.875)"
                  fill="#272727"
                />
                <rect
                  x="17.8594"
                  y="12.5391"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(30 17.8594 12.5391)"
                  fill="#272727"
                />
                <rect
                  x="5.21094"
                  y="1.94727"
                  width="0.830886"
                  height="4.56987"
                  transform="rotate(30 5.21094 1.94727)"
                  fill="#272727"
                />
                <rect
                  x="6.35938"
                  y="2.61328"
                  width="0.830886"
                  height="4.56987"
                  transform="rotate(30 6.35938 2.61328)"
                  fill="#272727"
                />
                <rect
                  x="4.05469"
                  y="1.2832"
                  width="0.830886"
                  height="4.56987"
                  transform="rotate(30 4.05469 1.2832)"
                  fill="#272727"
                />
                <rect
                  x="15.6641"
                  y="2.36328"
                  width="0.830886"
                  height="4.56987"
                  transform="rotate(-30 15.6641 2.36328)"
                  fill="#272727"
                />
                <rect
                  x="16.8203"
                  y="1.69922"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(-30 16.8203 1.69922)"
                  fill="#272727"
                />
                <rect
                  x="18.0625"
                  y="3.85742"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(-30 18.0625 3.85742)"
                  fill="#272727"
                />
                <rect
                  x="14.5156"
                  y="3.02734"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(-30 14.5156 3.02734)"
                  fill="#272727"
                />
                <rect
                  x="15.7656"
                  y="5.1875"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(-30 15.7656 5.1875)"
                  fill="#272727"
                />
                <rect
                  x="1.77344"
                  y="10.7949"
                  width="0.830886"
                  height="4.56987"
                  transform="rotate(-30 1.77344 10.7949)"
                  fill="#272727"
                />
                <rect
                  x="4.07812"
                  y="9.4668"
                  width="0.830886"
                  height="4.56987"
                  transform="rotate(-30 4.07812 9.4668)"
                  fill="#272727"
                />
                <rect
                  x="2.92188"
                  y="10.1309"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(-30 2.92188 10.1309)"
                  fill="#272727"
                />
                <rect
                  x="4.17188"
                  y="12.2891"
                  width="0.830886"
                  height="2.07721"
                  transform="rotate(-30 4.17188 12.2891)"
                  fill="#272727"
                />
              </g>
            </g>
          </g>
          <rect x="0.664062" y="0.5" width="20.3333" height="15" rx="3.5" stroke="white" strokeOpacity="0.2" />
          <defs>
            <clipPath id="clip0_7919_691676">
              <rect x="0.164062" width="21.3333" height="16" rx="4" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {variant === CountryIconVariant.th && (
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_7901_570972"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="22"
            height="16"
          >
            <path d="M21.9974 0H0.664062V16H21.9974V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_7901_570972)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.664062 10.666H21.9974V15.9993H0.664062V10.666Z"
              fill="#F50101"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M0.664062 0H21.9974V4H0.664062V0Z" fill="#F50101" />
            <path
              d="M0.664062 4.33398H-0.335938V5.33398V10.6673V11.6673H0.664062H21.9974H22.9974V10.6673V5.33398V4.33398H21.9974H0.664062Z"
              fill="#3D58DB"
              stroke="white"
              strokeWidth="2"
            />
          </g>
        </svg>
      )}
      {variant === CountryIconVariant.zh && (
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_7901_571214"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="22"
            height="16"
          >
            <path d="M0.664062 0H21.9974V16H0.664062V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_7901_571214)">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.664062 0V16H21.9974V0H0.664062Z" fill="#EF0000" />
            <mask
              id="mask1_7901_571214"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="22"
              height="16"
            >
              <path fillRule="evenodd" clipRule="evenodd" d="M0.664062 0V16H21.9974V0H0.664062Z" fill="white" />
            </mask>
            <g mask="url(#mask1_7901_571214)">
              <path fillRule="evenodd" clipRule="evenodd" d="M0.664062 0V9.33333H12.6641V0H0.664062Z" fill="#2E42A5" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.48329 7.20687L5.49552 8.43927L5.25626 6.87814L3.78465 7.45147L4.358 5.97987L2.79688 5.7406L4.02922 4.75283L2.79688 3.76505L4.358 3.52579L3.78465 2.05418L5.25626 2.62753L5.49552 1.06641L6.48329 2.29875L7.47104 1.06641L7.71031 2.62753L9.18191 2.05418L8.60857 3.52579L10.1697 3.76505L8.93738 4.75283L10.1697 5.7406L8.60857 5.97987L9.18191 7.45147L7.71031 6.87814L7.47104 8.43927L6.48329 7.20687ZM6.48329 6.66105C7.53717 6.66105 8.39151 5.80671 8.39151 4.75283C8.39151 3.69894 7.53717 2.84459 6.48329 2.84459C5.42941 2.84459 4.57506 3.69894 4.57506 4.75283C4.57506 5.80671 5.42941 6.66105 6.48329 6.66105ZM8.00991 4.75283C8.00991 5.59593 7.3264 6.27941 6.48329 6.27941C5.64019 6.27941 4.95671 5.59593 4.95671 4.75283C4.95671 3.90971 5.64019 3.22624 6.48329 3.22624C7.3264 3.22624 8.00991 3.90971 8.00991 4.75283Z"
                fill="#FEFFFF"
              />
            </g>
          </g>
        </svg>
      )}
      {variant === CountryIconVariant.ja && (
        <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_8596_140775"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="22"
            height="17"
          >
            <path d="M0.382812 0.253906H21.7161V16.2539H0.382812V0.253906Z" fill="white" />
          </mask>
          <g mask="url(#mask0_8596_140775)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.382812 0.253906V16.2539H21.7161V0.253906H0.382812Z"
              fill="#F7FCFF"
            />
            <mask
              id="mask1_8596_140775"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="22"
              height="17"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.382812 0.253906V16.2539H21.7161V0.253906H0.382812Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_8596_140775)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0527 13.2539C13.8141 13.2539 16.0527 11.0153 16.0527 8.25391C16.0527 5.49248 13.8141 3.25391 11.0527 3.25391C8.29133 3.25391 6.05273 5.49248 6.05273 8.25391C6.05273 11.0153 8.29133 13.2539 11.0527 13.2539Z"
                fill="#E31D1C"
              />
            </g>
          </g>
        </svg>
      )}
    </i>
  );
}

export default CountryIcon;
